package one.primehealth.analytics.di

import one.primehealth.analytics.AmplitudePlatform
import one.primehealth.analytics.AppAnalyticsPlatform
import org.koin.core.module.dsl.singleOf
import org.koin.dsl.module

internal actual val platformModule = module {
    singleOf(::AppAnalyticsPlatform)
    singleOf(::AmplitudePlatform)
}